<template>
  <div class="t-select-item">
    <!--渐变背景-->
    <div class="mask-box"></div>
    <!--选中行-->
    <div class="line-box centerY">
      <div class="border-1px-tb"></div>
    </div>
    <!--内容区域-->
    <div class="list-box" ref="list">
      <ul>
        <li v-for="item in list" v-text="listProp? item[listProp]:item"></li>
      </ul>
    </div>
  </div>
</template>
<script>
/*
   * @param list [Array] 滑动列表数据数组
   * @param listProp [String] 对象数组显示的属性，如果为字符串数组则该属性无效
   * @param value [String/Object] 列表滑动选中的字符串或对象
   * @param valueProp [String] 绑定值绑定的属性（当对象列表时有效，默认绑定就为对象本身）
   * @param primaryKey {String} 作为列表选中值判断的key（列表的某个属性名）
   * @param end {Function} 列表滑动结束触发事件，参数为选中值
   * @describe 需要配合tSelect组件一起使用,常与tSliderbox组件一起使用（该组件用于滑出滚动选择框）,注意value绑定值为对象时默认必须包含属性(不然无法监听到对象)
   *
   * @example
   *
    <t-sliderbox :show="isShowAreaDialog" direction="bottom">
      <t-selectbox @cancel="isShowAreaDialog = false" @ok="saveIntentionArea()">
        <t-selectitem :list="cityList" list-prop="name" v-model="city" @end="onSelectCity"></t-selectitem>
        <t-selectitem :list="districtList" v-model="district" list-prop="name"></t-selectitem>
      </t-selectbox>
    </t-sliderbox>
   * */
export default {
  name: 'tSelectitem',
  props: {
    list: { type: Array, required: true },
    listProp: { type: String, default: '' },
    value: [Object, String, Number],
    valueProp: { type: String, default: '' },
    primaryKey: { type: String, default: '' },
  },
  data() {
    return {
      ignoreTopNum: 3, // 初始顶部忽略数量
      singleHeight: 34, // 单个高度
      fingerInfo: { startY: 0, lastY: 0, startTime: 0, lastTime: 0, transformY: 0 },
      currentValue: this.value,
    };
  },
  watch: {
    list() {
      this.init();
    },
    value: {
      handler(val) {
         this.currentValue = val; // 对象类型需要深度监听
      },
      deep: true,
    }
  },
  mounted() {
    this.init();
    this.$el.addEventListener('touchstart', this.itemTouchStart);
    this.$el.addEventListener('touchmove', this.itemTouchMove);
    this.$el.addEventListener('touchend', this.itemTouchEnd);
  },
  methods: {
    /* 初始化状态 */
    init() {
      const myList = this.primaryKey ? this.list.map(t => `${t[this.primaryKey]}`) : this.list;
      const index = myList.indexOf(this.primaryKey ? `${this.currentValue[this.primaryKey]}` : this.value);
      if (index === -1) {
        this.setListTransform(this.singleHeight * this.ignoreTopNum, 1000, false);
        this.getPickValue(this.singleHeight * this.ignoreTopNum);
      } else {
        const move = (index - this.ignoreTopNum) * this.singleHeight;
        this.$emit('input', this.valueProp ? this.list[index][this.valueProp] : this.list[index]);
        /* 因为往上滑动所以是负且默认值已经存在无需调用getPickValue */
        this.setListTransform(-move, 1000, false);
      }
    },
    itemTouchStart(event) {
      const finger = event.changedTouches[0];
      this.fingerInfo.startY = finger.pageY;
      this.fingerInfo.startTime = event.timestamp || Date.now();
      this.fingerInfo.transformY = this.$refs.list.getAttribute('scroll'); // 获取
      event.preventDefault();
    },
    itemTouchMove(event) {
      const finger = event.changedTouches[0];
      this.fingerInfo.lastY = finger.pageY;
      this.fingerInfo.lastTime = event.timestamp || Date.now();
      const move = this.fingerInfo.lastY - this.fingerInfo.startY;
      this.setStyle(move);
      event.preventDefault();
    },
    itemTouchEnd(event) {
      const finger = event.changedTouches[0];
      this.fingerInfo.lastY = finger.pageY;
      this.fingerInfo.lastTime = event.timestamp || Date.now();
      let move = this.fingerInfo.lastY - this.fingerInfo.startY;
      let time = this.fingerInfo.lastTime - this.fingerInfo.startTime;
      const v = move / time; // 计算速度
      const a = 1.8; // 设置减速加速度a
      // 速度计算说明, 当时间小于300毫秒 最后的移动距离等于 move + 减速运动距离
      if (time <= 300) {
        move = v * a * time;
        time = 1000 + time * a;
        this.setStyle(move, 'end', time);
        return;
      }
      this.setStyle(move, 'end', time);
    },
    // 设置样式
    setStyle: function (move, type, time) {
      let updateMove = move + Number(this.fingerInfo.transformY);
      // 滑动到最顶部
      if (updateMove > this.singleHeight * this.ignoreTopNum) {
        updateMove = this.singleHeight * this.ignoreTopNum;
      }
      // 滑动到最底部
      if (updateMove < -(this.list.length - this.ignoreTopNum - 1) * this.singleHeight) {
        updateMove = -(this.list.length - this.ignoreTopNum - 1) * this.singleHeight;
      }
      // 滑动到指定区域内
      if (type === 'end') {
        updateMove = Math.round(updateMove / this.singleHeight) * this.singleHeight;
      }
      this.getPickValue(updateMove, type);
      this.setListTransform(updateMove, time);
    },
    // 动画效果
    setListTransform(translateY = 0, time = 1000, action = true) {
      this.$refs.list.style.webkitTransition = action ? `transform ${time}ms cubic-bezier(0.19, 1, 0.22, 1)` : '';
      this.$refs.list.style.webkitTransform = `translateY(${translateY}px)`;
      this.$refs.list.setAttribute('scroll', translateY); // 记录
    },
    // 获取选中值
    getPickValue(move, type) {
      if (this.list.length === 0) {
        return;
      }
      const index = this.ignoreTopNum - Math.round(move / this.singleHeight);
      this.currentValue = this.valueProp ? this.list[index][this.valueProp] : this.list[index];
      if (type === 'end') {
        this.$emit('end', this.list[index]);
      }
    },
    updateValue: function () {
      this.$emit('input', this.currentValue);
    },
  },
  beforeDestroy() {
    this.$el.removeEventListener('touchstart', this.itemTouchStart);
    this.$el.removeEventListener('touchmove', this.itemTouchMove);
    this.$el.removeEventListener('touchend', this.itemTouchEnd);
  },
};

</script>
<style lang="scss">
@import "../style/mixin";

.t-select-item {
  flex: 1;
  height: 238px;
  overflow: hidden;
  position: relative;
  background: #eeeeee;
  .mask-box {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
    z-index: 3;
    background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), linear-gradient(to top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));
    background-position: top, bottom;
    background-size: 100% 102px;
    background-repeat: no-repeat;
  }
  .line-box {
    width: 100%;
    height: 34px;
    z-index: 3;
    .border-1px-tb {
      height: 100%;
      @include border-1px-tb(#d0d0d0);
    }
  }
  .list-box {
    text-align: center;
    transform: translate3d(0px, 68px, 0px);
    ul li {
      font-size: 16px;
      height: 34px;
      line-height: 34px;
      color: #000;
      overflow: hidden;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/selectitem.vue